export default "__VITE_ASSET__d8328a25__"